import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api";
import { useAuth } from "../auth";
import logo from "../assets/estimate_tracker_logo.png";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { refresh } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await login(email, password);
      await refresh();
      navigate("/");
    } catch (e) {
      setErr(e.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <aside className="left">
        <div className="brand">
          <img className="brand-logo" src={logo} alt="" aria-hidden="true" />
          Estimate Tracker
        </div>
        <div className="pitch">
          <h1>Track estimates, agreements, and the work between.</h1>
          <p>
            See what your team estimates internally and what your clients see —
            all in one shared workspace.
          </p>
        </div>
        <div className="footer-note">Internal · v0.1</div>
      </aside>
      <section className="right">
        <form className="login-card" onSubmit={submit}>
          <h2>Sign in</h2>
          <div className="sub">Use your account to continue.</div>
          <div className="stack">
            <div>
              <label className="field">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                required
              />
            </div>
            <div>
              <label className="field">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {err && <div className="error">{err}</div>}
            <button type="submit" className="primary" disabled={busy}>
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}
